import { useQuery } from "@tanstack/react-query";
import { MobileContactPacketService } from "@/services/contact/MobileContactPacketService";
import type { ConversationContactPacket } from "@/types/contact/mobileContactPacket";
import type { Conversation } from "@/types/conversation/conversation";

const EMPTY: ConversationContactPacket = { callerE164: null, packet: null };

/**
 * The contact packet for a conversation's caller.
 *
 * Resolves the caller's number, then the caller-scoped brain memory holding
 * whatever they shared through the Help Genie app. Returns an empty result
 * rather than an error when there is no caller or nothing has been shared —
 * that is the normal state until the app-side collection (HG-1299) ships.
 */
export const useConversationContactPacket = (conversation: Conversation | null) =>
  useQuery<ConversationContactPacket>({
    queryKey: ["conversation-contact-packet", conversation?.id ?? null],
    queryFn: async () => {
      if (!conversation) return EMPTY;
      return MobileContactPacketService.getForConversation(conversation);
    },
    enabled: Boolean(conversation?.id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
